
import { useStore } from '@/store'
import { computed, defineComponent, inject, onUnmounted, ref, watch } from 'vue'
import * as RenderingConstants from '@/constants/rendering-constants'
import RenderingPathService from '@/services/rendering/rendering-path.service'
import bodySettings from '@/settings/body-settings.json'
import threadSettings from '@/settings/thread-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingRandselBody',
  props: {
    cameraPos: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configBodyId = computed(() => store.getters.configBodyId)
    const configThreadId = computed(() => store.getters.configThreadId)
    const configFrontId = computed(() => store.getters.configFrontId)
    let imagePath = ref('')
    let renderPathService = new RenderingPathService()

    emitter.on('updateConfig', updateRendering)

    // prettier-ignore
    watch(() => configBodyId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configThreadId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configFrontId.value, (_) => { updateRendering() })

    function updateRendering() {
      try {
        const bodyId = renderPathService.formatConfig(configBodyId.value, bodySettings.fullorderColors)
        const threadId = renderPathService.formatConfig(configThreadId.value, threadSettings.threadColors)
        setRendering(bodyId, threadId)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setRendering(bodyId: string | null, threadId: string | null) {
      if (!bodyId || !threadId) {
        if (!bodyId) {
          console.error('cannot find body id for RenderingRandselBody')
        }
        imagePath.value = ''
        return
      }

      const camPath = 'cam' + (props.cameraPos + 1) + '/'
      const optionPath = 'body/' + getFrontPath() + threadId + '/' + bodyId + '.png'
      const path = RenderingConstants.path + camPath + optionPath
      console.log(path)
      imagePath.value = path
    }

    function getFrontPath() {
      if (configFrontId.value == "8") {
        return "futaRibbon/"
      } else if (configFrontId.value == "10") {
        return "futaRainbow/"
      }
      else {
        return "futaDefault/"
      }
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateRendering)
    })

    return {
      imagePath
    }
  }
})
